var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333252 0.333496H1.66659V1.66683H0.333252V0.333496Z",
    fill: "#797979"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66667 1.66683H19.6667C19.8435 1.66683 20.013 1.59659 20.1381 1.47157C20.2631 1.34654 20.3333 1.17697 20.3333 1.00016C20.3333 0.823352 20.2631 0.653783 20.1381 0.528758C20.013 0.403734 19.8435 0.333496 19.6667 0.333496H3.66667C3.48986 0.333496 3.32029 0.403734 3.19526 0.528758C3.07024 0.653783 3 0.823352 3 1.00016C3 1.17697 3.07024 1.34654 3.19526 1.47157C3.32029 1.59659 3.48986 1.66683 3.66667 1.66683Z",
    fill: "#797979"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.333252 4.3335H1.66659V5.66683H0.333252V4.3335Z",
    fill: "#797979"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6667 4.3335H3.66667C3.48986 4.3335 3.32029 4.40373 3.19526 4.52876C3.07024 4.65378 3 4.82335 3 5.00016C3 5.17697 3.07024 5.34654 3.19526 5.47157C3.32029 5.59659 3.48986 5.66683 3.66667 5.66683H19.6667C19.8435 5.66683 20.013 5.59659 20.1381 5.47157C20.2631 5.34654 20.3333 5.17697 20.3333 5.00016C20.3333 4.82335 20.2631 4.65378 20.1381 4.52876C20.013 4.40373 19.8435 4.3335 19.6667 4.3335Z",
    fill: "#797979"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.333252 8.3335H1.66659V9.66683H0.333252V8.3335Z",
    fill: "#797979"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6667 8.3335H3.66667C3.48986 8.3335 3.32029 8.40373 3.19526 8.52876C3.07024 8.65378 3 8.82335 3 9.00016C3 9.17697 3.07024 9.34654 3.19526 9.47157C3.32029 9.59659 3.48986 9.66683 3.66667 9.66683H19.6667C19.8435 9.66683 20.013 9.59659 20.1381 9.47157C20.2631 9.34654 20.3333 9.17697 20.3333 9.00016C20.3333 8.82335 20.2631 8.65378 20.1381 8.52876C20.013 8.40373 19.8435 8.3335 19.6667 8.3335Z",
    fill: "#797979"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.333252 12.3335H1.66659V13.6668H0.333252V12.3335Z",
    fill: "#797979"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6667 12.3335H3.66667C3.48986 12.3335 3.32029 12.4037 3.19526 12.5288C3.07024 12.6538 3 12.8234 3 13.0002C3 13.177 3.07024 13.3465 3.19526 13.4716C3.32029 13.5966 3.48986 13.6668 3.66667 13.6668H19.6667C19.8435 13.6668 20.013 13.5966 20.1381 13.4716C20.2631 13.3465 20.3333 13.177 20.3333 13.0002C20.3333 12.8234 20.2631 12.6538 20.1381 12.5288C20.013 12.4037 19.8435 12.3335 19.6667 12.3335Z",
    fill: "#797979"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListView);
export default __webpack_public_path__ + "static/media/list-view.ae7c8406c521017cb07b4ed0e0f55d2c.svg";
export { ForwardRef as ReactComponent };